import React from "react";

const SearchIcon = (props) => {
    return(
        <svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg"><path d="M6.75 2.75c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4-1.791-4-4-4zm-6 4c0-3.314 2.686-6 6-6s6 2.686 6 6c0 1.292-.408 2.489-1.103 3.468l2.063 2.078c.389.392.387 1.025-.005 1.414s-1.025.387-1.414-.005l-2.055-2.07c-.982.702-2.186 1.115-3.485 1.115-3.314 0-6-2.686-6-6z" fill={props.fill} /></svg>
    )
}

export default SearchIcon;